module.exports = __webpack_public_path__ + "static/media/GS.28fa20c8.png";